export default __webpack_public_path__ + "static/media/logout-btn.4c9b7156.svg";